import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';

import { ToastService } from 'app/libs/toast';

type TokenError = Partial<HttpErrorResponse> & {
    code?: string;
    name?: string;
    friendlyMessage?: string;
    url?: string;
};

export const apiErrorInterceptorFn: HttpInterceptorFn = (req, next) => {
    const toast = inject(ToastService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            let customMessage = 'An unexpected error occurred. Please try again.';

            if (error.status === 401) {
                customMessage = 'Your session has expired. Please log in again.';
            } else if (error.status === 403) {
                customMessage = 'You do not have permission to perform this action.';
            } else if (error.status >= 500) {
                customMessage = 'Server is currently unavailable. Please try later.';
            }

            toast.error(customMessage);

            // You can log, show a toast, or even redirect here
            console.error('Custom Error:', customMessage, error);

            return throwError(() => ({
                ...error,
                message: customMessage
            }));
        })
    );
};

export const tokenErrorInterceptorFn: HttpInterceptorFn = (req, next) => {
    const toast = inject(ToastService);

    return next(req).pipe(
        catchError((err: TokenError) => {
            // Heuristics for Auth0 token errors (SDKs use different shapes)
            const isAuth0TokenError =
                err?.error === 'login_required' ||
                err?.code === 'login_required' ||
                err?.error === 'consent_required' ||
                err?.code === 'consent_required' ||
                (err?.status === 401 && !err?.url); // 401 thrown before an actual HTTP call

            console.log('dd', isAuth0TokenError);
            if (isAuth0TokenError) {
                const friendly = 'Your session has expired. Please log in again.';
                console.warn('[TokenErrorInterceptor]', friendly, err);
                err.friendlyMessage = friendly;
                toast.error(friendly);
            }
            return throwError(() => err);
        })
    );
};
